import {
  RightOutlined,
  SafetyCertificateFilled,
} from '@ant-design/icons';
import { useLanguage } from 'hooks/Language/useLanguage';

const RADIUS = 19;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

/**
 * Floating way back into the verification modal while documents are still
 * missing: a progress ring around the shield plus how many are left.
 * Collapses to the ring alone on small screens.
 */
const KycReminder: React.FC<{
  done: number;
  total: number;
  onOpen: () => void;
}> = ({ done, total, onOpen }) => {
  const { translate } = useLanguage();
  const left = Math.max(total - done, 0);
  const progress = total ? done / total : 0;

  return (
    <button
      type="button"
      className="kyc-reminder"
      onClick={onOpen}
      aria-label={`${translate('Finish verification')}: ${left} ${translate(
        left === 1 ? 'document left' : 'documents left',
      )}`}
    >
      <span className="kyc-reminder__ring">
        <svg viewBox="0 0 44 44" aria-hidden="true">
          <circle
            className="kyc-reminder__track"
            cx="22"
            cy="22"
            r={RADIUS}
          />
          <circle
            className="kyc-reminder__fill"
            cx="22"
            cy="22"
            r={RADIUS}
            strokeDasharray={CIRCUMFERENCE}
            strokeDashoffset={CIRCUMFERENCE * (1 - progress)}
          />
        </svg>
        <SafetyCertificateFilled />
        <span className="kyc-reminder__count">{left}</span>
      </span>
      <span className="kyc-reminder__text">
        <strong>{translate('Finish verification')}</strong>
        <span>
          {left}{' '}
          {translate(left === 1 ? 'document left' : 'documents left')}
        </span>
      </span>
      <RightOutlined className="kyc-reminder__arrow" />
    </button>
  );
};

export default KycReminder;
